<template>
  <v-container fluid class="pa-0" id="speeddial">
    <CalendarMenu :printEvents="printEvents"/>
    <!--
    <v-snackbar v-model="msg" top :vertical="true">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="msg = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    -->
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn>
    </v-snackbar>
    <v-progress-linear
      :active="isLoading"
      indeterminate
    ></v-progress-linear>

    <v-row id="noPrint">
      <v-col lg="2" sm="12">
        <v-container>
          <v-col cols="12">
            <p>FILTER BY:</p>
          </v-col>

          <v-col cols="12">
            <v-btn-toggle class="btn-group--active d-block">
              <v-btn
                text
                outlined
                small
                width="100%"
                color="grey darken-4"
                min-height="40"
                elevation="0"
                @click="programDialog = true"
              >
                <span color="white">Program</span>
                <v-icon small color="black" class="ml-2">
                  mdi-chevron-down
                </v-icon>
              </v-btn>
            </v-btn-toggle>
            <v-dialog
              v-model="programDialog"
              scrollable
              max-width="300px"
            >
              <v-card>
                <v-card-title>Select Program</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px">
                  <div
                    v-for="program in programs"
                    :key="program._id"
                  >
                    <v-checkbox
                      v-model="programSelected"
                      :label="program.Name"
                      :value="program._id"
                    ></v-checkbox>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="programDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="#2b3990"
                    class="white--text"
                    @click="getEvents(calendarEventDate)"
                  >
                    Filter & Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>

          <v-col cols="12">
            <v-btn-toggle class="btn-group--active d-block">
              <v-btn
                text
                outlined
                small
                width="100%"
                color="grey darken-4"
                min-height="40"
                elevation="0"
                @click="clientDialog = true"
              >
                <span color="white">Client</span>
                <v-icon small color="black" class="ml-2">
                  mdi-chevron-down
                </v-icon>
              </v-btn>
            </v-btn-toggle>
            <v-dialog
              v-model="clientDialog"
              scrollable
              max-width="300px"
            >
              <v-card>
                <v-card-title>Select Client</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px">
                  <!-- Client Status Filter -->
                  <v-select
                    label="Client Status"
                    :items="clientStatuses"
                    v-model="clientStatus"
                    prepend-icon="person"
                    clearable
                  ></v-select>

                  <!-- Client Search/Selection Filter -->
                  <v-select
                    :label="
                                            isLoading
                                                ? 'Loading...'
                                                : 'Select Clients'
                                        "
                    :items="filteredClients"
                    item-value="_id"
                    item-text="Name"
                    v-model="clientSelected"
                    multiple
                    prepend-icon="person"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-text-field
                            v-model="clientSearch"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            clearable
                            @input="filterClients"
                          ></v-text-field>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                    </template>
                  </v-select>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="clientDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="#2b3990"
                    class="white--text"
                    @click="getEvents(calendarEventDate)"
                  >
                    Filter & Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>

          <v-col cols="12">
            <v-btn-toggle class="btn-group--active d-block">
              <v-btn
                text
                outlined
                small
                width="100%"
                color="grey darken-4"
                min-height="40"
                elevation="0"
                @click="staffDialog = true"
              >
                <span color="white">Staff</span>
                <v-icon small color="black" class="ml-2">
                  mdi-chevron-down
                </v-icon>
              </v-btn>
            </v-btn-toggle>
            <v-dialog
              v-model="staffDialog"
              scrollable
              max-width="300px"
            >
              <v-card>
                <v-card-title>Select Staff</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px">
                  <div v-for="user in users" :key="user._id">
                    <v-checkbox
                      v-model="staffSelected"
                      :label="user.Name"
                      :value="user._id"
                    ></v-checkbox>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="staffDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="#2b3990"
                    class="white--text"
                    @click="getEvents(calendarEventDate)"
                  >
                    Filter & Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>

          <v-col cols="12">
            <v-btn-toggle class="btn-group--active d-block">
              <v-btn
                text
                outlined
                small
                width="100%"
                color="grey darken-4"
                min-height="40"
                elevation="0"
                @click="eventDialog = true"
              >
                <span color="white">Event</span>
                <v-icon small color="black" class="ml-2">
                  mdi-chevron-down
                </v-icon>
              </v-btn>
            </v-btn-toggle>
            <v-dialog
              v-model="eventDialog"
              scrollable
              max-width="300px"
            >
              <v-card>
                <v-card-title>Select Event</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px">
                  <div
                    v-for="event in eventTypes"
                    :key="event.Name"
                  >
                    <v-checkbox
                      v-model="eventSelected"
                      :label="event"
                      :value="event"
                    ></v-checkbox>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="eventDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="#2b3990"
                    class="white--text"
                    @click="getEvents(calendarEventDate)"
                  >
                    Filter & Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>

          <v-col cols="12">
            <v-btn-toggle class="btn-group--active d-block">
              <v-btn
                text
                outlined
                small
                width="100%"
                color="grey darken-1"
                min-height="40"
                elevation="0"
                @click="clearSearchData()"
              >
                <span>Clear</span>
                <v-icon small color="black" class="ml-2">
                  mdi-close
                </v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-container>
      </v-col>

      <v-col lg="10" sm="12">
        <v-sheet height="64" class="mb-n3 mt-5">
          <v-toolbar flat>
            <div v-show="!$vuetify.breakpoint.smAndDown"></div>

            <v-spacer
              v-show="!$vuetify.breakpoint.smAndDown"
            ></v-spacer>

            <v-btn-toggle relative>
              <v-btn
                fab
                text
                small
                color="grey darken-4"
                @click="prev"
              >
                <v-icon small> mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn
                outlined
                color=" darken-2"
                small
                @click="setToday"
                min-height="40"
              >
                Today
              </v-btn>
              <v-btn
                outlined
                color="grey darken-4"
                small
                min-height="40"
              >
                                <span v-if="$refs.calendar">
                                    {{ $refs.calendar.title }}
                                </span>
              </v-btn>
              <v-btn
                fab
                text
                small
                color="grey darken-4"
                @click="next"
              >
                <v-icon small> mdi-chevron-right</v-icon>
              </v-btn>
            </v-btn-toggle>

            <v-spacer></v-spacer>

            <div v-show="!$vuetify.breakpoint.smAndDown">
              <v-menu bottom right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn-toggle>
                    <v-btn
                      outlined
                      color="grey darken-4"
                      min-height="40"
                      v-bind="attrs"
                      v-on="on"
                      small
                    >
                      <span>{{ typeToLabel[type] }}</span>
                      <v-icon right>
                        mdi-menu-down
                      </v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </template>
                <v-list>
                  <v-list-item @click="setType('day')">
                    <v-list-item-title
                    >Day
                    </v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item @click="setType('week')">
                    <v-list-item-title
                    >Week
                    </v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item @click="setType('month')">
                    <v-list-item-title
                    >Month
                    </v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item @click="setType('4day')">
                    <v-list-item-title
                    >4 days
                    </v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-dialog v-model="addDialog" max-width="75%">
                <template v-slot:activator="{ on }">
                  <v-btn
                    dark
                    small
                    color="indigo darken-4"
                    min-height="40"
                    elevation="0"
                    class="ml-2"
                    @click="printEvents()"
                    v-if="!directCareStaff"
                  >
                    <v-icon small color="white">
                      mdi-printer
                    </v-icon>
                    <span color="white"> Print Event</span>
                  </v-btn>
                  <v-btn
                    dark
                    small
                    color="indigo darken-4"
                    min-height="40"
                    elevation="0"
                    class="ml-2"
                    v-on="on"
                    @click="showAdd()"
                    v-if="!directCareStaff"
                  >
                    <v-icon small color="white">
                      mdi-plus
                    </v-icon>
                    <span color="white">Add Event</span>
                  </v-btn>
                </template>

                <calendar-add-cal-dialog
                  :get-events="getEvents"
                  :title-form="titleForm"
                  :close="close"
                  :clients="clients"
                  :programs="programs"
                  :users="users"
                  :clientEvents="clientEvents"
                  :staffEvents="staffEvents"
                  :visitTypes="sortedVisitType"
                  :providers="providers"
                  @addCalendarEvent="addCalendarEvent($event)"
                />
              </v-dialog>
            </div>

            <v-btn
              icon
              class="calendar--menu"
              @click="setCalendarDrawer(!calendarDrawer)"
              v-show="$vuetify.breakpoint.smAndDown"
            >
              <v-icon> mdi-menu</v-icon>
            </v-btn>
          </v-toolbar>
        </v-sheet>

        <v-sheet class="ma-4">
          <v-calendar
            ref="calendar"
            v-model="focus"
            :type="type"
            :events="events"
            :event-color="getEventColor"
            :event-height="65"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="getEvents"
          >
            <template v-slot:event="{ event }">
              <strong style="margin-left: 1px; display: block">
                                <span
                                >{{ event.startTime }} -
                                    {{ event.endTime }}</span
                                >
              </strong>
              <div>
                <strong
                  style="margin-left: 1px; display: block"
                >
                  <span>{{ event.clientName }}</span>
                </strong>
              </div>
              <div>
                <strong
                  style="margin-left: 1px; display: block"
                >
                  <span>{{ event.event }}</span>
                </strong>
              </div>
            </template>
          </v-calendar>
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            transition="scale-transition"
          >
            <calendar-update-cal-dialog
              :get-events="getEvents"
              :title-form="titleForm"
              :update-close="updateClose"
              :event-data="selectedEvent"
              :clients="clients"
              :programs="programs"
              :users="users"
              :clientEvents="clientEvents"
              :staffEvents="staffEvents"
              :visitTypes="sortedVisitType"
              @updateCalendarEvent="updateCalendarEvent($event)"
              @deleteSchedule="deleteSchedule($event)"
            />
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
    <div id="printTable">
      <h2 class="text-center ma-3">Calendar Events</h2>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="eventHeaders"
            :items="events"
            sort-by="startDate"
            sort-asc
            :loading="isLoading"
            loading-text="Loading Events"
            height="auto"
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0"
          >
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
/*eslint-disable */
import CalendarAddCalDialog from "@/components/Calendar/addDialogCal.vue";
import CalendarUpdateCalDialog from "@/components/Calendar/updateDialogCal.vue";
import CalendarMenu from "@/components/Calendar/CalendarMenu";
// import Foot from '@/components/Footer'
import axios from "axios";
import moment from "moment";
import {mapMutations, mapState} from "vuex";
import {datetime, RRule} from "rrule";
import DateTimeUtil from "../../utils/date-time.util.js";

const CalendarService = require("../service/calendar.service");
const url = require("../client_config/config").url;
const CLIENT_STATUS_OPTIONS = ["Active", "Inactive", "All"];

export default {
  components: {
    CalendarAddCalDialog,
    CalendarUpdateCalDialog,
    CalendarMenu,
    // Foot
  },
  data: () => ({
    directCareStaff: false,
    fab: false,
    msg: false,
    // type: 'month',
    text: "",
    focus: "",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    events: [],
    activities: [],
    clients: [],
    programs: [],
    users: [],
    leads: [],
    dragEvent: null,
    dragStart: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    selectedStart: new Date(),
    selectedEnd: new Date(
      new Date().setTime(new Date().getTime() + 8 * 60 * 60 * 1000)
    ),
    titleForm: "New Event",
    isLoading: false,
    color: "success",
    statusFilter: "All",
    loaderCounter: 0,
    programId: "",
    event: "",
    programSelected: [],
    programFilter: "",
    clientSelected: [],
    staffSelected: [],
    providers: [],
    eventSelected: "",
    userState: localStorage.getItem("userState"),
    eventTypes: [
      "Dr. Visit",
      "Family Visit",
      "Reminder",
      "Appointment",
      "Activity",
      "Menu",
      "Birthday",
      "CPR/FA",
      "New Hire Orientation",
      "Med Certification",
      "Safety Care",
      "Admin Meeting",
      "Program Manager Meeting",
      "House Manager Meeting",
      "Other",
    ],
    clientEvents: [
      "Activity",
      "Appointment",
      "Birthday",
      "Dr. Visit",
      "Family Visit",
      "Meeting",
      "Menu",
      "Other",
      "Reminder",
      "Vocational Rehabilitation",
      "Maintenance",
      "Work",
    ],
    staffEvents: [
      "Team Meeting",
      "Program Meeting",
      "Birthday",
      "CPR/FA",
      "New Hire Orientation",
      "Med Certification",
      "Safety Care",
      "Admin Meeting",
      "Program Manager Meeting",
      "House Manager Meeting",
      "Maintenance",
    ],
    visitTypes: [
      "Admitting Physician",
      "Allergist",
      "Appointed Attorney",
      "Attending Physician",
      "Appointed Attorney",
      "Audiologist",
      "Behaviorist",
      "Cardiologist",
      "Care Worker Supervisor",
      "Case Worker",
      "Chiropractor",
      "Counselor/Therapist",
      "Dentist",
      "Dermatologist",
      "Ears, Nose and Throat (ENT)",
      "Emergency Room",
      "Employer",
      "Endocrinologist",
      "Gastroenterologist",
      "Gynecologist",
      "Hospital",
      "Lab",
      "Legal Guardian",
      "Nephrologist",
      "Neurologist",
      "Nurse",
      "Nurse Practitioner",
      "Nutritionist/Dietician",
      "Occupational Therapist",
      "Optometrist/Ophthalmologist",
      "Orthopedic",
      "Parent (Connect Access)",
      "Pharmacy",
      "Phlebotomist",
      "Physical Therapist",
      "Physician or Specialist",
      "Physician Assistant",
      "Podiatrist",
      "Primary Care MD",
      "Psychiatrist",
      "Public Guardian",
      "Radiologist",
      "Sleep Specialist",
      "Support Coordinator",
      "Surgeon",
      "Urologist",
      "Urgent Care",
      "Work Site",
      "Wound Care",
    ],
    colors: "grey darken-1",
    calendarEventDate: {},
    selectedCalendarEventStartDate: "",
    selectedCalendarEventEndDate: "",
    eventHeaders: [
      {
        text: "Event",
        align: "start",
        sortable: true,
        value: "event",
      },
      {text: "Staff", value: "staff.Name"},
      {text: "Client", value: "client.Name"},
      {text: "Start Date", value: "startDate"},
      {text: "End Date", value: "endDate"},

      {text: "Note", value: "note"},
    ],
    userRole: localStorage.getItem("userRole"),
    clientStatuses: CLIENT_STATUS_OPTIONS,
    clientStatus: "Active", // Load active clients by default
    filteredClients: [],
    clientSearch: "",
  }),

  created() {
    this.getClients();
    this.getStaff();
    this.getPrograms();
    let calendarEventId = this.$route.query.view;

    if (calendarEventId) {
      CalendarService.getById(calendarEventId).then((response) => {
        this.selectedEvent = this.mapCalendarEvent(response.data);
        this.selectedOpen = true;
      });
    }
  },

  computed: {
    ...mapState({
      calendarDrawer: (state) => state.calendarDrawer,
      type: (state) => state.type,
    }),

    programDialog: {
      get() {
        return this.$store.state.calendar.programDialog;
      },
      set(val) {
        this.setProgramDialog(val);
      },
    },

    sortedVisitType() {
      return this.visitTypes.slice().sort();
    },

    eventDialog: {
      get() {
        return this.$store.state.calendar.eventDialog;
      },
      set(val) {
        this.setEventDialog(val);
      },
    },

    clientDialog: {
      get() {
        return this.$store.state.calendar.clientDialog;
      },
      set(val) {
        this.setClientDialog(val);
      },
    },

    staffDialog: {
      get() {
        return this.$store.state.calendar.staffDialog;
      },
      set(val) {
        this.setStaffDialog(val);
      },
    },

    addDialog: {
      get() {
        return this.$store.state.calendar.addEventDialog;
      },
      set(val) {
        this.setAddEventDialog(val);
      },
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    clientStatus: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) this.getClients();
      },
    },
  },
  methods: {
    ...mapMutations({
      setType: "SET_TYPE",
      setChat: "SET_CHAT",
      setEventDialog: "calendar/SET_EVENT_DIALOG",
      setProgramDialog: "calendar/SET_PROGRAM_DIALOG",
      setClientDialog: "calendar/SET_CLIENT_DIALOG",
      setStaffDialog: "calendar/SET_STAFF_DIALOG",
      setAddEventDialog: "calendar/SET_ADD_EVENT_DIALOG",
      setCalendarDrawer: "SET_CALENDAR_DRAWER",
    }),

    async getClients() {
      if (localStorage.getItem("userRole") === "Direct Care Staff") {
        this.directCareStaff = true;
      }
      let params = {};
      let endpoint = `${url}/clients`;

      const companyIds = localStorage.getItem("userCompanies");

      if (this.userRole !== "SuperAdministrator") {
        // If not SuperAdmin, filter fetched data based on the user's Company
        params["Company:in"] = JSON.parse(companyIds);

        // If user belongs to Admin group but its user role is not Administration,
        // filter fetched data based on the user's State
        if (this.userRole !== "Administration") {
          params["State"] = this.userState;
        }
      }

      if (this.clientStatus !== "All") {
        params["Status"] = this.clientStatus;
      }

      await axios.get(endpoint, {params}).then((res) => {
        this.clients = res.data.clients;
        this.filteredClients = res.data.clients;
      });
    },

    async getStaff() {
      let endpoint = "";
      const companyIds = localStorage.getItem("userCompanies");

      endpoint = `${url}/users/state/${this.userState}`;

      await axios
        .get(endpoint, {
          params: {
            Company: JSON.parse(companyIds),
          },
        })
        .then((res) => {
          this.users = res.data.users;
        });
    },

    async getPrograms() {
      const companyIds = localStorage.getItem("userCompanies");

      await axios
        .get(`${url}/units/state/${this.userState}`, {
          params: {
            Company: JSON.parse(companyIds),
          },
        })
        .then((res) => {
          this.programs = res.data.units;
        });
    },

    // getProviders() {
    //     axios.get(`${url}/providers`).then(async res => {
    //         this.providers = res.data.providers;
    //     });
    // },

    getEventColor(event) {
      return event.color;
    },

    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    viewDay({date}) {
      this.focus = date;
      this.setType("day");
    },

    setToday() {
      this.focus = "";
    },

    prev() {
      this.$refs.calendar.prev();
    },

    next() {
      this.$refs.calendar.next();
    },

    showAdd() {
      this.setAddEventDialog(true);
      this.titleForm = "New Event";
    },

    close() {
      this.setAddEventDialog(false);
    },

    updateClose() {
      this.selectedOpen = false;

      if (this.$router.currentRoute.path !== "/calendar") {
        this.$router.replace({path: "/calendar"});
      }
    },

    getEvents(e) {
      if (!e) {
        return;
      }

      const userState = this.userState;
      this.calendarEventDate = e;
      let {
        start: {date: startDate},
        end: {date: endDate},
      } = e || {};
      this.selectedCalendarEventStartDate = startDate;
      this.selectedCalendarEventEndDate = endDate;

      startDate = moment(startDate).startOf("day").toISOString();
      endDate = moment(endDate).endOf("day").toISOString();

      this.programDialog = false;
      this.clientDialog = false;
      this.staffDialog = false;
      this.eventDialog = false;
      this.isLoading = true;

      const companyIds = localStorage.getItem("userCompanies");

      const params = {
        programIds: this.programSelected?.toString(),
        clientIds: this.clientSelected?.toString(),
        staffIds: this.staffSelected?.toString(),
        eventTypes: this.eventSelected?.toString(),
        startDate,
        endDate,
        state: userState,
        limit: -1,
      };

      CalendarService.get(params)
        .then((res) => {
          this.isLoading = false;
          let rawEvents = res.data.docs;
          let transformedEvents = [];

          rawEvents.forEach((calendarEvent) => {
            if (
              calendarEvent.isRecurringEvent &&
              calendarEvent.isRecurringEvent === "Yes"
            ) {
              transformedEvents = transformedEvents.concat(
                this.formatToRecurringCalendarEvent(
                  calendarEvent,
                  startDate,
                  endDate
                )
              );
            } else {
              transformedEvents.push(
                this.mapCalendarEvent(calendarEvent)
              );
            }
          });

          this.events = transformedEvents.filter((event) => {
            console.log({transformedEventsFilter: event.event});
            return (
              this.eventSelected === "Menu" ||
              event.event !== "Menu"
            );
          });

          console.log({filteredEvents: this.events});

          this.displayEvent(this.events);
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
          this.msg = true;
          this.text = err;
          this.color = "red";
          this.events = [];
        });
    },

    mapCalendarEvents(calendarEvents) {
      if (!calendarEvents) {
        return [];
      }

      return calendarEvents.map((calendarEvent) => {
        if (calendarEvent.isRecurringEvent === "Yes") {
          return this.formatToRecurringCalendarEvent(
            calendarEvent,
            startDate,
            endDate
          );
        } else {
          return this.mapCalendarEvent(calendarEvent);
        }
      });
    },

    mapCalendarEvent(calendarEvent) {
      console.log({calendarEvent});

      if (!calendarEvent) {
        return {};
      }

      const {Program} = calendarEvent;
      return {
        id: calendarEvent._id,
        start: moment(calendarEvent.StartDate).format("YYYY-MM-DD"),
        end: moment(calendarEvent.EndDate).format("YYYY-MM-DD"),
        startTime: moment(calendarEvent.StartDate).format("h:mma"),
        startDate: moment(calendarEvent.StartDate).format(
          "YYYY-MM-DD HH:mm"
        ),
        endDate: moment(calendarEvent.EndDate).format(
          "YYYY-MM-DD HH:mm"
        ),
        endTime: moment(calendarEvent.EndDate).format("h:mma"),
        color: Program?.ShiftColor || this.colors,
        event: calendarEvent.Event,
        name: `${calendarEvent?.Client?.Name} - ${calendarEvent.Event}`,
        client: calendarEvent.Client,
        clientName: calendarEvent?.Client?.Name,
        staff: calendarEvent.Staff,
        program: calendarEvent.Program,
        note: calendarEvent.MedicalVisit?.Reason || calendarEvent.Notes,
        transportation: calendarEvent.Transportation,
        Tfrom: calendarEvent.From,
        Tto: calendarEvent.To,
        createdBy: calendarEvent.CreatedBy,
        createdDate: moment(calendarEvent.CreatedDate).format(
          "YYYY-MM-DD"
        ),
        signature: calendarEvent.Signature,
        visitID: calendarEvent.VisitID,
        eventFor: calendarEvent.EventFor,
        medicalVisit: calendarEvent.MedicalVisit,
        isRecurringEvent: calendarEvent.isRecurringEvent,
        selectedOption: calendarEvent.typeOfRecurringEvent,
      };
    },

    formatToRecurringCalendarEvent(calendarEvent, startDate, endDate) {
      let StartDate = calendarEvent.StartDate;
      let EndDate = calendarEvent.EndDate;

      const shiftStartTime = moment(calendarEvent.StartDate).format(
        "HH:mm"
      );
      const shiftEndTime = moment(calendarEvent.EndDate).format("HH:mm");

      const recurringYear = moment(StartDate).utc().year();
      const recurringMonth = moment(StartDate).utc().format("M");
      const recurringDay = moment(StartDate).utc().format("D");
      const recurringHour = moment(StartDate).utc().format("HH");
      const recurringMinute = moment(StartDate).utc().format("mm");

      const recurringEndYear = moment(EndDate).utc().year();
      const recurringEndMonth = moment(EndDate).utc().format("M");
      const recurringEndDay = moment(EndDate).utc().format("D");
      const recurringEndHour = moment(EndDate).utc().format("HH");
      const recurringEndMinute = moment(EndDate).utc().format("mm");

      const recurringTypeSwitch = (eventType) =>
        ({
          Daily: RRule.DAILY,
          Weekly: RRule.WEEKLY,
          Monthly: RRule.MONTHLY,
          Annually: RRule.YEARLY,
        }[eventType]);

      const recurringDates = new RRule({
        freq: recurringTypeSwitch(calendarEvent.typeOfRecurringEvent),
        dtstart: datetime(
          parseInt(recurringYear),
          parseInt(recurringMonth),
          parseInt(recurringDay),
          parseInt(recurringHour),
          parseInt(recurringMinute)
        ),
        until: datetime(
          parseInt(recurringEndYear),
          parseInt(recurringEndMonth),
          parseInt(recurringEndDay),
          parseInt(recurringEndHour),
          parseInt(recurringEndMinute)
        ),
        interval: 1,
      });

      const formattedRecurringDates = recurringDates
        .all()
        .map((date) => moment(date).format("YYYY-MM-DD"));
      const finalListOfRecurringEvents = [];

      formattedRecurringDates.forEach((recurringDate) => {
        let date = recurringDate;
        recurringDate = moment(
          date + " " + shiftStartTime,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm");

        if (shiftEndTime < shiftStartTime) {
          date = moment(date).add(1, "days").format("YYYY-MM-DD");
        }

        let endDate = moment(
          date + " " + shiftEndTime,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm");

        const start = moment(recurringDate).format("YYYY-MM-DD");
        const end = moment(endDate).format("YYYY-MM-DD");

        finalListOfRecurringEvents.push({
          // id: calendarEvent._id, Note: This 'id' will cause 'duplicate key' since this event is recurring, as default this is Calendar 'key'
          recurringEventId: calendarEvent._id, //Set identifier to update and delete recurring events
          start: start,
          end: end,
          startTime: moment(calendarEvent.StartDate).format("h:mma"),
          startDate: moment(StartDate).format("YYYY-MM-DD HH:mm"),
          endDate: moment(EndDate).format("YYYY-MM-DD HH:mm"),
          endTime: moment(calendarEvent.EndDate).format("h:mma"),
          color: calendarEvent.Program?.ShiftColor || this.colors,
          event: calendarEvent.Event,
          name: `${calendarEvent?.Client?.Name} - ${calendarEvent.Event}`,
          client: calendarEvent.Client,
          clientName: calendarEvent?.Client?.Name,
          staff: calendarEvent.Staff,
          program: calendarEvent?.Program,
          note:
            calendarEvent.MedicalVisit?.Reason ||
            calendarEvent.Notes,
          transportation: calendarEvent.Transportation,
          Tfrom: calendarEvent.From,
          Tto: calendarEvent.To,
          createdBy: calendarEvent.CreatedBy,
          createdDate: moment(calendarEvent.CreatedDate).format(
            "YYYY-MM-DD"
          ),
          signature: calendarEvent.Signature,
          visitID: calendarEvent.VisitID,
          eventFor: calendarEvent.EventFor,
          medicalVisit: calendarEvent.MedicalVisit,
          isRecurringEvent: calendarEvent.isRecurringEvent,
          selectedOption: calendarEvent.typeOfRecurringEvent,
        });
      });

      return finalListOfRecurringEvents;
    },

    showEvent({nativeEvent, event}) {
      console.log({nativeEvent: nativeEvent});
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        this.selectedStart = new Date(event.start);
        this.selectedEnd = new Date(event.end);
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },

    updateCalendarEvent(data) {
      this.msg = data.msg;
      this.text = data.text;
      this.color = data.color;
      this.updateClose();
      window.location.reload();
      this.close();
    },

    addCalendarEvent(data) {
      this.msg = data.msg;
      this.text = data.text;
      this.color = data.color;
      this.addDialog = data.addDialog;
      window.location.reload();
      this.close();
    },

    deleteSchedule(data) {
      this.msg = data.msg;
      this.text = data.text;
      this.color = data.color;
      this.updateClose();
    },

    clearSearchData() {
      this.programSelected = [];
      this.clientSelected = [];
      this.staffSelected = [];
      this.eventSelected = "";
      this.getEvents(this.calendarEventDate);
    },

    displayEvent(events) {
      const eventIdParameter = this.$route.params.id;

      if (eventIdParameter) {
        let event = events.find((item) => item.id === eventIdParameter);

        if (!event) {
          this.$router.replace({path: "/calendar"});
          return;
        }

        this.selectedEvent = event;
        this.selectedOpen = true;
      }
    },

    printEvents() {
      //document.getElementById("printTable").style.display = "block";
      window.print();
    },

    /**
     * Filters the clients based on the search query.
     *
     * This method converts the client's name and the search query to lowercase,
     * and then checks if the client's name includes the search query.
     * The filtered clients are stored in the `filteredClients` array.
     */
    filterClients() {
      const clientSearch = this.clientSearch.toLowerCase();
      this.filteredClients = this.clients.filter((client) =>
        client.Name.toLowerCase().includes(clientSearch)
      );
    },
  },
};
</script>
<style scoped lang="scss">
.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: "";
  }

  &:hover::after {
    display: block;
  }
}

.v-application {
  justify-content: center;
}

.calendar--menu {
  position: absolute !important;
  right: 0;
  margin-right: 0px !important;
}

.btn-group--active.v-btn--active::before {
  opacity: 0 !important;
}

#speeddial .v-speed-dial {
  position: absolute;
}

#speeddial .v-btn--floating {
  position: relative;
}

#printTable {
  display: none;
}

@media print {
  #printTable {
    display: block;
    border: none;
    //width: 800px;
    padding-right: 10px;
    margin-left: -300px;
    padding-left: 0px;
    margin-right: 100px;
  }

  #noPrint {
    display: none;
  }

  .hideOnPrint {
    display: none;
    border: none;
  }

  nav.v-navigation-drawer,
  header.v-toolbar,
  button.v-btn,
  div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }
}
</style>
<style scoped>
.v-calendar-daily__body {
  display: none !important;
}
</style>
